module.exports = __webpack_public_path__ + "7076a47d75ffbe0812ef260bed7afb11.pdf";